/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'

const WeeklyContestLazyRouteImport = createFileRoute('/weekly-contest')()
const VipLazyRouteImport = createFileRoute('/vip')()
const TokenLazyRouteImport = createFileRoute('/token')()
const TermsOfServiceLazyRouteImport = createFileRoute('/terms-of-service')()
const SuiroyaleLazyRouteImport = createFileRoute('/suiroyale')()
const SlushWalletCampaignLazyRouteImport = createFileRoute(
  '/slush-wallet-campaign',
)()
const RoadmapLazyRouteImport = createFileRoute('/roadmap')()
const RewardsLazyRouteImport = createFileRoute('/rewards')()
const ReferralLazyRouteImport = createFileRoute('/referral')()
const RangeLazyRouteImport = createFileRoute('/range')()
const QuestsDocLazyRouteImport = createFileRoute('/quests-doc')()
const QuestsLazyRouteImport = createFileRoute('/quests')()
const ProfileLazyRouteImport = createFileRoute('/profile')()
const PrivacyPolicyLazyRouteImport = createFileRoute('/privacy-policy')()
const PlinkoLazyRouteImport = createFileRoute('/plinko')()
const OauthCallbackLazyRouteImport = createFileRoute('/oauth-callback')()
const NotFoundLazyRouteImport = createFileRoute('/not-found')()
const NftLazyRouteImport = createFileRoute('/nft')()
const LootboxLazyRouteImport = createFileRoute('/lootbox')()
const LimboLazyRouteImport = createFileRoute('/limbo')()
const LayoutPlaygroundLazyRouteImport = createFileRoute('/layout-playground')()
const GamesLazyRouteImport = createFileRoute('/games')()
const CoinflipLazyRouteImport = createFileRoute('/coinflip')()
const BrandkitLazyRouteImport = createFileRoute('/brandkit')()
const IndexLazyRouteImport = createFileRoute('/')()
const SuiroyaleProfileLazyRouteImport = createFileRoute('/suiroyale/profile')()
const SuiroyaleAirdropLazyRouteImport = createFileRoute('/suiroyale/airdrop')()
const SuiroyaleAboutLazyRouteImport = createFileRoute('/suiroyale/about')()
const SocialConnectLazyRouteImport = createFileRoute('/social/connect')()
const EmailVerifyLazyRouteImport = createFileRoute('/email/verify')()
const CoinbaseOfframpLazyRouteImport = createFileRoute('/coinbase/offramp')()
const SuiroyaleGameIdLazyRouteImport = createFileRoute('/suiroyale/game/$id')()

const WeeklyContestLazyRoute = WeeklyContestLazyRouteImport.update({
  id: '/weekly-contest',
  path: '/weekly-contest',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/weekly-contest.lazy').then((d) => d.Route),
)
const VipLazyRoute = VipLazyRouteImport.update({
  id: '/vip',
  path: '/vip',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/vip.lazy').then((d) => d.Route))
const TokenLazyRoute = TokenLazyRouteImport.update({
  id: '/token',
  path: '/token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/token.lazy').then((d) => d.Route))
const TermsOfServiceLazyRoute = TermsOfServiceLazyRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/terms-of-service.lazy').then((d) => d.Route),
)
const SuiroyaleLazyRoute = SuiroyaleLazyRouteImport.update({
  id: '/suiroyale',
  path: '/suiroyale',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/suiroyale.lazy').then((d) => d.Route))
const SlushWalletCampaignLazyRoute = SlushWalletCampaignLazyRouteImport.update({
  id: '/slush-wallet-campaign',
  path: '/slush-wallet-campaign',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/slush-wallet-campaign.lazy').then((d) => d.Route),
)
const RoadmapLazyRoute = RoadmapLazyRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/roadmap.lazy').then((d) => d.Route))
const RewardsLazyRoute = RewardsLazyRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/rewards.lazy').then((d) => d.Route))
const ReferralLazyRoute = ReferralLazyRouteImport.update({
  id: '/referral',
  path: '/referral',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/referral.lazy').then((d) => d.Route))
const RangeLazyRoute = RangeLazyRouteImport.update({
  id: '/range',
  path: '/range',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/range.lazy').then((d) => d.Route))
const QuestsDocLazyRoute = QuestsDocLazyRouteImport.update({
  id: '/quests-doc',
  path: '/quests-doc',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/quests-doc.lazy').then((d) => d.Route))
const QuestsLazyRoute = QuestsLazyRouteImport.update({
  id: '/quests',
  path: '/quests',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/quests.lazy').then((d) => d.Route))
const ProfileLazyRoute = ProfileLazyRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/profile.lazy').then((d) => d.Route))
const PrivacyPolicyLazyRoute = PrivacyPolicyLazyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/privacy-policy.lazy').then((d) => d.Route),
)
const PlinkoLazyRoute = PlinkoLazyRouteImport.update({
  id: '/plinko',
  path: '/plinko',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/plinko.lazy').then((d) => d.Route))
const OauthCallbackLazyRoute = OauthCallbackLazyRouteImport.update({
  id: '/oauth-callback',
  path: '/oauth-callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/oauth-callback.lazy').then((d) => d.Route),
)
const NotFoundLazyRoute = NotFoundLazyRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/not-found.lazy').then((d) => d.Route))
const NftLazyRoute = NftLazyRouteImport.update({
  id: '/nft',
  path: '/nft',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/nft.lazy').then((d) => d.Route))
const LootboxLazyRoute = LootboxLazyRouteImport.update({
  id: '/lootbox',
  path: '/lootbox',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/lootbox.lazy').then((d) => d.Route))
const LimboLazyRoute = LimboLazyRouteImport.update({
  id: '/limbo',
  path: '/limbo',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/limbo.lazy').then((d) => d.Route))
const LayoutPlaygroundLazyRoute = LayoutPlaygroundLazyRouteImport.update({
  id: '/layout-playground',
  path: '/layout-playground',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/layout-playground.lazy').then((d) => d.Route),
)
const GamesLazyRoute = GamesLazyRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/games.lazy').then((d) => d.Route))
const CoinflipLazyRoute = CoinflipLazyRouteImport.update({
  id: '/coinflip',
  path: '/coinflip',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/coinflip.lazy').then((d) => d.Route))
const BrandkitLazyRoute = BrandkitLazyRouteImport.update({
  id: '/brandkit',
  path: '/brandkit',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/brandkit.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const SuiroyaleProfileLazyRoute = SuiroyaleProfileLazyRouteImport.update({
  id: '/suiroyale/profile',
  path: '/suiroyale/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/suiroyale.profile.lazy').then((d) => d.Route),
)
const SuiroyaleAirdropLazyRoute = SuiroyaleAirdropLazyRouteImport.update({
  id: '/suiroyale/airdrop',
  path: '/suiroyale/airdrop',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/suiroyale.airdrop.lazy').then((d) => d.Route),
)
const SuiroyaleAboutLazyRoute = SuiroyaleAboutLazyRouteImport.update({
  id: '/suiroyale/about',
  path: '/suiroyale/about',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/suiroyale.about.lazy').then((d) => d.Route),
)
const SocialConnectLazyRoute = SocialConnectLazyRouteImport.update({
  id: '/social/connect',
  path: '/social/connect',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/social/connect.lazy').then((d) => d.Route),
)
const EmailVerifyLazyRoute = EmailVerifyLazyRouteImport.update({
  id: '/email/verify',
  path: '/email/verify',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/email/verify.lazy').then((d) => d.Route))
const CoinbaseOfframpLazyRoute = CoinbaseOfframpLazyRouteImport.update({
  id: '/coinbase/offramp',
  path: '/coinbase/offramp',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/coinbase.offramp.lazy').then((d) => d.Route),
)
const SuiroyaleGameIdLazyRoute = SuiroyaleGameIdLazyRouteImport.update({
  id: '/suiroyale/game/$id',
  path: '/suiroyale/game/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/suiroyale.game.$id.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/brandkit': typeof BrandkitLazyRoute
  '/coinflip': typeof CoinflipLazyRoute
  '/games': typeof GamesLazyRoute
  '/layout-playground': typeof LayoutPlaygroundLazyRoute
  '/limbo': typeof LimboLazyRoute
  '/lootbox': typeof LootboxLazyRoute
  '/nft': typeof NftLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/oauth-callback': typeof OauthCallbackLazyRoute
  '/plinko': typeof PlinkoLazyRoute
  '/privacy-policy': typeof PrivacyPolicyLazyRoute
  '/profile': typeof ProfileLazyRoute
  '/quests': typeof QuestsLazyRoute
  '/quests-doc': typeof QuestsDocLazyRoute
  '/range': typeof RangeLazyRoute
  '/referral': typeof ReferralLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/roadmap': typeof RoadmapLazyRoute
  '/slush-wallet-campaign': typeof SlushWalletCampaignLazyRoute
  '/suiroyale': typeof SuiroyaleLazyRoute
  '/terms-of-service': typeof TermsOfServiceLazyRoute
  '/token': typeof TokenLazyRoute
  '/vip': typeof VipLazyRoute
  '/weekly-contest': typeof WeeklyContestLazyRoute
  '/coinbase/offramp': typeof CoinbaseOfframpLazyRoute
  '/email/verify': typeof EmailVerifyLazyRoute
  '/social/connect': typeof SocialConnectLazyRoute
  '/suiroyale/about': typeof SuiroyaleAboutLazyRoute
  '/suiroyale/airdrop': typeof SuiroyaleAirdropLazyRoute
  '/suiroyale/profile': typeof SuiroyaleProfileLazyRoute
  '/suiroyale/game/$id': typeof SuiroyaleGameIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/brandkit': typeof BrandkitLazyRoute
  '/coinflip': typeof CoinflipLazyRoute
  '/games': typeof GamesLazyRoute
  '/layout-playground': typeof LayoutPlaygroundLazyRoute
  '/limbo': typeof LimboLazyRoute
  '/lootbox': typeof LootboxLazyRoute
  '/nft': typeof NftLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/oauth-callback': typeof OauthCallbackLazyRoute
  '/plinko': typeof PlinkoLazyRoute
  '/privacy-policy': typeof PrivacyPolicyLazyRoute
  '/profile': typeof ProfileLazyRoute
  '/quests': typeof QuestsLazyRoute
  '/quests-doc': typeof QuestsDocLazyRoute
  '/range': typeof RangeLazyRoute
  '/referral': typeof ReferralLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/roadmap': typeof RoadmapLazyRoute
  '/slush-wallet-campaign': typeof SlushWalletCampaignLazyRoute
  '/suiroyale': typeof SuiroyaleLazyRoute
  '/terms-of-service': typeof TermsOfServiceLazyRoute
  '/token': typeof TokenLazyRoute
  '/vip': typeof VipLazyRoute
  '/weekly-contest': typeof WeeklyContestLazyRoute
  '/coinbase/offramp': typeof CoinbaseOfframpLazyRoute
  '/email/verify': typeof EmailVerifyLazyRoute
  '/social/connect': typeof SocialConnectLazyRoute
  '/suiroyale/about': typeof SuiroyaleAboutLazyRoute
  '/suiroyale/airdrop': typeof SuiroyaleAirdropLazyRoute
  '/suiroyale/profile': typeof SuiroyaleProfileLazyRoute
  '/suiroyale/game/$id': typeof SuiroyaleGameIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/brandkit': typeof BrandkitLazyRoute
  '/coinflip': typeof CoinflipLazyRoute
  '/games': typeof GamesLazyRoute
  '/layout-playground': typeof LayoutPlaygroundLazyRoute
  '/limbo': typeof LimboLazyRoute
  '/lootbox': typeof LootboxLazyRoute
  '/nft': typeof NftLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/oauth-callback': typeof OauthCallbackLazyRoute
  '/plinko': typeof PlinkoLazyRoute
  '/privacy-policy': typeof PrivacyPolicyLazyRoute
  '/profile': typeof ProfileLazyRoute
  '/quests': typeof QuestsLazyRoute
  '/quests-doc': typeof QuestsDocLazyRoute
  '/range': typeof RangeLazyRoute
  '/referral': typeof ReferralLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/roadmap': typeof RoadmapLazyRoute
  '/slush-wallet-campaign': typeof SlushWalletCampaignLazyRoute
  '/suiroyale': typeof SuiroyaleLazyRoute
  '/terms-of-service': typeof TermsOfServiceLazyRoute
  '/token': typeof TokenLazyRoute
  '/vip': typeof VipLazyRoute
  '/weekly-contest': typeof WeeklyContestLazyRoute
  '/coinbase/offramp': typeof CoinbaseOfframpLazyRoute
  '/email/verify': typeof EmailVerifyLazyRoute
  '/social/connect': typeof SocialConnectLazyRoute
  '/suiroyale/about': typeof SuiroyaleAboutLazyRoute
  '/suiroyale/airdrop': typeof SuiroyaleAirdropLazyRoute
  '/suiroyale/profile': typeof SuiroyaleProfileLazyRoute
  '/suiroyale/game/$id': typeof SuiroyaleGameIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/brandkit'
    | '/coinflip'
    | '/games'
    | '/layout-playground'
    | '/limbo'
    | '/lootbox'
    | '/nft'
    | '/not-found'
    | '/oauth-callback'
    | '/plinko'
    | '/privacy-policy'
    | '/profile'
    | '/quests'
    | '/quests-doc'
    | '/range'
    | '/referral'
    | '/rewards'
    | '/roadmap'
    | '/slush-wallet-campaign'
    | '/suiroyale'
    | '/terms-of-service'
    | '/token'
    | '/vip'
    | '/weekly-contest'
    | '/coinbase/offramp'
    | '/email/verify'
    | '/social/connect'
    | '/suiroyale/about'
    | '/suiroyale/airdrop'
    | '/suiroyale/profile'
    | '/suiroyale/game/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/brandkit'
    | '/coinflip'
    | '/games'
    | '/layout-playground'
    | '/limbo'
    | '/lootbox'
    | '/nft'
    | '/not-found'
    | '/oauth-callback'
    | '/plinko'
    | '/privacy-policy'
    | '/profile'
    | '/quests'
    | '/quests-doc'
    | '/range'
    | '/referral'
    | '/rewards'
    | '/roadmap'
    | '/slush-wallet-campaign'
    | '/suiroyale'
    | '/terms-of-service'
    | '/token'
    | '/vip'
    | '/weekly-contest'
    | '/coinbase/offramp'
    | '/email/verify'
    | '/social/connect'
    | '/suiroyale/about'
    | '/suiroyale/airdrop'
    | '/suiroyale/profile'
    | '/suiroyale/game/$id'
  id:
    | '__root__'
    | '/'
    | '/brandkit'
    | '/coinflip'
    | '/games'
    | '/layout-playground'
    | '/limbo'
    | '/lootbox'
    | '/nft'
    | '/not-found'
    | '/oauth-callback'
    | '/plinko'
    | '/privacy-policy'
    | '/profile'
    | '/quests'
    | '/quests-doc'
    | '/range'
    | '/referral'
    | '/rewards'
    | '/roadmap'
    | '/slush-wallet-campaign'
    | '/suiroyale'
    | '/terms-of-service'
    | '/token'
    | '/vip'
    | '/weekly-contest'
    | '/coinbase/offramp'
    | '/email/verify'
    | '/social/connect'
    | '/suiroyale/about'
    | '/suiroyale/airdrop'
    | '/suiroyale/profile'
    | '/suiroyale/game/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  BrandkitLazyRoute: typeof BrandkitLazyRoute
  CoinflipLazyRoute: typeof CoinflipLazyRoute
  GamesLazyRoute: typeof GamesLazyRoute
  LayoutPlaygroundLazyRoute: typeof LayoutPlaygroundLazyRoute
  LimboLazyRoute: typeof LimboLazyRoute
  LootboxLazyRoute: typeof LootboxLazyRoute
  NftLazyRoute: typeof NftLazyRoute
  NotFoundLazyRoute: typeof NotFoundLazyRoute
  OauthCallbackLazyRoute: typeof OauthCallbackLazyRoute
  PlinkoLazyRoute: typeof PlinkoLazyRoute
  PrivacyPolicyLazyRoute: typeof PrivacyPolicyLazyRoute
  ProfileLazyRoute: typeof ProfileLazyRoute
  QuestsLazyRoute: typeof QuestsLazyRoute
  QuestsDocLazyRoute: typeof QuestsDocLazyRoute
  RangeLazyRoute: typeof RangeLazyRoute
  ReferralLazyRoute: typeof ReferralLazyRoute
  RewardsLazyRoute: typeof RewardsLazyRoute
  RoadmapLazyRoute: typeof RoadmapLazyRoute
  SlushWalletCampaignLazyRoute: typeof SlushWalletCampaignLazyRoute
  SuiroyaleLazyRoute: typeof SuiroyaleLazyRoute
  TermsOfServiceLazyRoute: typeof TermsOfServiceLazyRoute
  TokenLazyRoute: typeof TokenLazyRoute
  VipLazyRoute: typeof VipLazyRoute
  WeeklyContestLazyRoute: typeof WeeklyContestLazyRoute
  CoinbaseOfframpLazyRoute: typeof CoinbaseOfframpLazyRoute
  EmailVerifyLazyRoute: typeof EmailVerifyLazyRoute
  SocialConnectLazyRoute: typeof SocialConnectLazyRoute
  SuiroyaleAboutLazyRoute: typeof SuiroyaleAboutLazyRoute
  SuiroyaleAirdropLazyRoute: typeof SuiroyaleAirdropLazyRoute
  SuiroyaleProfileLazyRoute: typeof SuiroyaleProfileLazyRoute
  SuiroyaleGameIdLazyRoute: typeof SuiroyaleGameIdLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/weekly-contest': {
      id: '/weekly-contest'
      path: '/weekly-contest'
      fullPath: '/weekly-contest'
      preLoaderRoute: typeof WeeklyContestLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vip': {
      id: '/vip'
      path: '/vip'
      fullPath: '/vip'
      preLoaderRoute: typeof VipLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/token': {
      id: '/token'
      path: '/token'
      fullPath: '/token'
      preLoaderRoute: typeof TokenLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suiroyale': {
      id: '/suiroyale'
      path: '/suiroyale'
      fullPath: '/suiroyale'
      preLoaderRoute: typeof SuiroyaleLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slush-wallet-campaign': {
      id: '/slush-wallet-campaign'
      path: '/slush-wallet-campaign'
      fullPath: '/slush-wallet-campaign'
      preLoaderRoute: typeof SlushWalletCampaignLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roadmap': {
      id: '/roadmap'
      path: '/roadmap'
      fullPath: '/roadmap'
      preLoaderRoute: typeof RoadmapLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rewards': {
      id: '/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof RewardsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referral': {
      id: '/referral'
      path: '/referral'
      fullPath: '/referral'
      preLoaderRoute: typeof ReferralLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/range': {
      id: '/range'
      path: '/range'
      fullPath: '/range'
      preLoaderRoute: typeof RangeLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quests-doc': {
      id: '/quests-doc'
      path: '/quests-doc'
      fullPath: '/quests-doc'
      preLoaderRoute: typeof QuestsDocLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quests': {
      id: '/quests'
      path: '/quests'
      fullPath: '/quests'
      preLoaderRoute: typeof QuestsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plinko': {
      id: '/plinko'
      path: '/plinko'
      fullPath: '/plinko'
      preLoaderRoute: typeof PlinkoLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth-callback': {
      id: '/oauth-callback'
      path: '/oauth-callback'
      fullPath: '/oauth-callback'
      preLoaderRoute: typeof OauthCallbackLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nft': {
      id: '/nft'
      path: '/nft'
      fullPath: '/nft'
      preLoaderRoute: typeof NftLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lootbox': {
      id: '/lootbox'
      path: '/lootbox'
      fullPath: '/lootbox'
      preLoaderRoute: typeof LootboxLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/limbo': {
      id: '/limbo'
      path: '/limbo'
      fullPath: '/limbo'
      preLoaderRoute: typeof LimboLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/layout-playground': {
      id: '/layout-playground'
      path: '/layout-playground'
      fullPath: '/layout-playground'
      preLoaderRoute: typeof LayoutPlaygroundLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games': {
      id: '/games'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof GamesLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coinflip': {
      id: '/coinflip'
      path: '/coinflip'
      fullPath: '/coinflip'
      preLoaderRoute: typeof CoinflipLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brandkit': {
      id: '/brandkit'
      path: '/brandkit'
      fullPath: '/brandkit'
      preLoaderRoute: typeof BrandkitLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suiroyale/profile': {
      id: '/suiroyale/profile'
      path: '/suiroyale/profile'
      fullPath: '/suiroyale/profile'
      preLoaderRoute: typeof SuiroyaleProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suiroyale/airdrop': {
      id: '/suiroyale/airdrop'
      path: '/suiroyale/airdrop'
      fullPath: '/suiroyale/airdrop'
      preLoaderRoute: typeof SuiroyaleAirdropLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suiroyale/about': {
      id: '/suiroyale/about'
      path: '/suiroyale/about'
      fullPath: '/suiroyale/about'
      preLoaderRoute: typeof SuiroyaleAboutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/social/connect': {
      id: '/social/connect'
      path: '/social/connect'
      fullPath: '/social/connect'
      preLoaderRoute: typeof SocialConnectLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email/verify': {
      id: '/email/verify'
      path: '/email/verify'
      fullPath: '/email/verify'
      preLoaderRoute: typeof EmailVerifyLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coinbase/offramp': {
      id: '/coinbase/offramp'
      path: '/coinbase/offramp'
      fullPath: '/coinbase/offramp'
      preLoaderRoute: typeof CoinbaseOfframpLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suiroyale/game/$id': {
      id: '/suiroyale/game/$id'
      path: '/suiroyale/game/$id'
      fullPath: '/suiroyale/game/$id'
      preLoaderRoute: typeof SuiroyaleGameIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  BrandkitLazyRoute: BrandkitLazyRoute,
  CoinflipLazyRoute: CoinflipLazyRoute,
  GamesLazyRoute: GamesLazyRoute,
  LayoutPlaygroundLazyRoute: LayoutPlaygroundLazyRoute,
  LimboLazyRoute: LimboLazyRoute,
  LootboxLazyRoute: LootboxLazyRoute,
  NftLazyRoute: NftLazyRoute,
  NotFoundLazyRoute: NotFoundLazyRoute,
  OauthCallbackLazyRoute: OauthCallbackLazyRoute,
  PlinkoLazyRoute: PlinkoLazyRoute,
  PrivacyPolicyLazyRoute: PrivacyPolicyLazyRoute,
  ProfileLazyRoute: ProfileLazyRoute,
  QuestsLazyRoute: QuestsLazyRoute,
  QuestsDocLazyRoute: QuestsDocLazyRoute,
  RangeLazyRoute: RangeLazyRoute,
  ReferralLazyRoute: ReferralLazyRoute,
  RewardsLazyRoute: RewardsLazyRoute,
  RoadmapLazyRoute: RoadmapLazyRoute,
  SlushWalletCampaignLazyRoute: SlushWalletCampaignLazyRoute,
  SuiroyaleLazyRoute: SuiroyaleLazyRoute,
  TermsOfServiceLazyRoute: TermsOfServiceLazyRoute,
  TokenLazyRoute: TokenLazyRoute,
  VipLazyRoute: VipLazyRoute,
  WeeklyContestLazyRoute: WeeklyContestLazyRoute,
  CoinbaseOfframpLazyRoute: CoinbaseOfframpLazyRoute,
  EmailVerifyLazyRoute: EmailVerifyLazyRoute,
  SocialConnectLazyRoute: SocialConnectLazyRoute,
  SuiroyaleAboutLazyRoute: SuiroyaleAboutLazyRoute,
  SuiroyaleAirdropLazyRoute: SuiroyaleAirdropLazyRoute,
  SuiroyaleProfileLazyRoute: SuiroyaleProfileLazyRoute,
  SuiroyaleGameIdLazyRoute: SuiroyaleGameIdLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
